import React, { useState, useContext, useEffect, useCallback } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button, Modal } from 'syngenta-react-components'
import { useForm } from 'react-hook-form'
import { GlobalContext, AuthContext } from '../../../services/context'
import { updateCompanyDetails, getTraining, postCheckedStatus, patchCheckedStatus, getHighestRole, updateCompanyNonEnogen, getProgram, postProgramAssignments, getProgramAssignments, getSalesYear, deleteProgramAssignment, deleteProgramAssignments, getMultiProductionPlans } from '../../../services/apiHelper'
import deleteIcon from '../../../assets/icons/close.svg'
import unChecked from '../../../assets/icons/circle_empty.svg'
import checked from '../../../assets/icons/circle_check_green.svg'
import arrow from '../../../dpe-usco/asset/icons/right_arrow.svg'
import Warning from '../../../components/subComponents/Notifications/Warning'
import './CompanyDetailComponent.scss'
import Select from '../../../dpe-usco/components/Select/Select'

const CompanyDetailComponent = ({ detailData, patchHandler, companyID, get_company, contractYear, SAPId, companyInfo, prodPlanData }) => {
  const { trackEvent } = useContext(GlobalContext)
  const [, setToggleForm] = useState(false)
  const { dispatch, state } = useContext(GlobalContext)
  const [newDetailName, setNewDetailName] = useState('')
  const [newDetailValue, setNewDetailValue] = useState('')
  const [showCompanyDetailsModal, setShowCompanyDetailsModal] = useState(false)
  const { register, handleSubmit, errors } = useForm()
  const [showWarning, setShowWarning] = useState(false)
  const [detailName, setDetailName] = useState()
  const [detailIndex, setDetailIndex] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { hasAccess } = useContext(AuthContext)
  const [access, setAccess] = useState()
  const [trainingCompleted, setTrainingCompleted] = useState(false)
  const [contactName, setContactName] = useState('N/A')
  const [contactEmail, setContactEmail] = useState('N/A')
  const [showCompanyDetails, setShowCompanyDetails] = useState(false)
  const [auth, setAuth] = useState(false)
  const [loader, setLoader] = useState(false)
  const [nonEnogenLoader, setNonEnogenLoader] = useState(false)
  const [isNonEnogenDealer, setIsNonEnogenDealer] = useState(false)
  const [isProgramsPermission, setIsProgramsPermission] = useState(false)
  const [filteredProgramDetails, setFilteredProgramDetails] = useState([])
  const [selectedProgramName, setSelectedProgramName] = useState({ program_name:'', program_id:'' })
  const [selectedProgramYear, setSelectedProgramYear] = useState({ production_plan_year:'', production_plan_id:'' })
  const [oldProgramdetails, setOldProgramDetails] = useState({ program_name:'', program_year:'', assignment_id:'' })
  const [programAssignLoader, setProgramAssignLoader] = useState(false)
  const [contractYears, setContractYears] = useState([])
  const [programCheckingLoader, setProgramCheckLoader] = useState(false)
  const [allowNonEnogenContracts, setAllowNonEnogenContracts] = useState(false)
  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear().toString()
  )
  const[isProgramExist, setProgramExist] = useState(false)
  const[programDetails, setProgramDetails] = useState([])
  
  useEffect(()=> {
    getSalesYear().then(sales_year => {
      setCurrentYear(sales_year.data.sales_year)
    }) 
  },[])
  useEffect(()=>{
    if(companyInfo?.allow_non_enogen_contracts) {
      setAllowNonEnogenContracts(companyInfo?.allow_non_enogen_contracts)
    }
  },[companyInfo])

  const onSubmit = data => {
    if (Object.entries(errors).length === 0) {
      const patchArg = {
        company_id: companyID,
        details: [...detailData, data]
      }
      patchHandler(patchArg)
      setToggleForm(prev => !prev)
    }
  }

  const refreshCompanyName = company_name => {
    const dispatchObj = { type: 'SET_DETAIL_VIEW', payload: { title: company_name, previous: state.detailView.previous } }
    dispatch(dispatchObj)
  }

  const _handleSubmit = async (e, result) => {
    e.preventDefault()
    setIsLoading(true)
    await updateCompanyDetails(companyID, [...detailData, { details_name: newDetailName, details_value: newDetailValue }])
    const company = await get_company()
    refreshCompanyName(company.company_name)
    handleSubmit(onSubmit)
    handleCompanyDetailsModalClose()
    setIsLoading(false)
  }

  const nonEnogenStatus = async e => {
    e.preventDefault()
    setNonEnogenLoader(true)
    await updateCompanyNonEnogen(companyID, !allowNonEnogenContracts)
    const company = await get_company()
    setAllowNonEnogenContracts(company?.allow_non_enogen_contracts)
    setNonEnogenLoader(false)
  }

  const handleCancel = e => {
    e.preventDefault()
    handleCompanyDetailsModalClose()
  }

  const handleDeleteDetail = async index => {
    setIsLoading(true)
    let copyDetail = [...detailData]
    copyDetail.splice(index, 1)
    let patchArg = {
      company_id: companyID,
      details: copyDetail
    }
    await patchHandler(patchArg)
    setShowWarning(false)
    setIsLoading(false)
  }

  const handleClickDelete = (index, item) => {
    setDetailIndex(index)
    setDetailName(item.details_name)
    setShowWarning(true)
  }

  useEffect(() => {
    const permissions = ['update-company', 'update-assigned-company']
    if(hasAccess(companyID, permissions) === 'SUCCESS'){
      setAccess('SUCCESS')
    }
  }, [
    companyID, hasAccess, trackEvent
  ])


  const handleCompanyDetailsModalClose = () => {
    setShowCompanyDetailsModal(false)
    setNewDetailName('')
    setNewDetailValue('')
  }

  let renderData = detailData && detailData.map((item, index) => {
    return (
      <div className='tal mb5' key={index}>
        <div className='df jcsb'>
          <div>
            <div className='df fxdrc tal'>
              <div className='fw700 mr5'>Name:</div>
              
              {item.details_name}
            </div>
            <div className='df fxdrc tal'>
              <div className='fw700 mr5'>Detail:</div>
              {item.details_value}
            </div>
          </div>
          <div className='w5% tar df aic'>
            {access === 'SUCCESS'
              ?
              <button onClick={() => handleClickDelete(index, item)}  className='bgc-t bdnone curp fz15 fw700 pr20'>
                <img
                  alt='delete button icon'
                  src={deleteIcon}/>
              </button>
              :
              null
            }
          </div>
        </div>
        {detailData && index < (detailData.length -1) && <div className='bb1-s-lightgray hide-tablet pt10 mb10'/>}         
      </div>
    )
  })

  useEffect(() => {
    if(SAPId && contractYear){
      getTraining(SAPId, contractYear).then(res => {
        if(res?.data.success === 'true'){
          if(res.data.active === 'true' || res.data.active === true){
            setTrainingCompleted(true)
            res.data.contact_name ? setContactName(res.data.contact_name) : setContactName('N/A')
            res.data.contact_email ? setContactEmail(res.data.contact_email) : setContactEmail('N/A')
          } else{
            setTrainingCompleted(false)
          }
        } else{
          setTrainingCompleted(false)
        }
      })
    } else{
      setTrainingCompleted(false)
    }
  }, [SAPId, contractYear])

  useEffect(() => {
    
    getHighestRole()?.then(res => {
      if(res.permissions && res.permissions.includes('company-training')){
        setAuth(true)
      } else{
        setAuth(false)
      }
      if(res.permissions.includes('allow-non-enogen-dealer-to-contract')){
        setIsNonEnogenDealer(true)
      } else{
        setIsNonEnogenDealer(false)
      }
      if(res.permissions.includes('show-programs')){
        setIsProgramsPermission(true)
      }else{
        setIsProgramsPermission(false)
      }
    })
   
    getProgramDetails()
  }, [])

  const getProgramDetails = () => {
    getProgram()
      .then(res => {
        if (res?.data.programs.length) {
          setProgramDetails(res.data.programs)
          const filteredData = res.data.programs.filter(x=>x.is_active).map( res => ({ id: res.program_id, value: res.program_name }) )
          setFilteredProgramDetails(filteredData)
        }
      })
  }

  useEffect(()=> {
    if(prodPlanData && prodPlanData.length >0) {
      const getYearAndProdPlanId = prodPlanData
        .map(item => ({ value: item.contract_year, id: item.production_plan_id }))
        .filter((value, index, self) => index === self.findIndex(t => t.value === value.value))
        .sort((a,b) => b.value - a.value)
      const filteredYear = prodPlanData.filter(data => (data.contract_year).toString() === currentYear.toString())
      if(filteredYear.length > 0) {
        const obj = {
          production_plan_year: filteredYear[0].contract_year, 
          production_plan_id: filteredYear[0].production_plan_id
        }
        setSelectedProgramYear(obj)
        setOldProgramDetails({ ...oldProgramdetails, program_year: filteredYear[0].contract_year })
      }else {
        setSelectedProgramYear({ production_plan_year:'', production_plan_id:'' })
        setOldProgramDetails({ ...oldProgramdetails, program_year: '' })
      }

      setContractYears(getYearAndProdPlanId)
    }
  },[prodPlanData])

  const assignProgramAssignments = async() => {
    const reqPayload = {
      program_id: selectedProgramName.program_id,
      company_id: companyID,
      production_plan_id: selectedProgramYear.production_plan_id
    }
    setProgramAssignLoader(true)
    try{
      await postProgramAssignments(reqPayload)
      setProgramAssignLoader(false)
      setProgramCheckLoader(true)
      getProgramDetails()
      setProgramExist(false)
    }
    catch(error) {
      setProgramAssignLoader(false)
    }
  }

  const deleteProgram = async() => {
    
    setProgramAssignLoader(true)
    try{
      await deleteProgramAssignments(oldProgramdetails.assignment_id)
      setProgramAssignLoader(false)
      setProgramExist(false)
      getProgramDetails()
      setProgramCheckLoader(true)
    }
    catch(error) {
      setProgramAssignLoader(false)
    }
  }

  const showCompanyDetailsFunc = () => {
    setShowCompanyDetails(prev => !prev)
  }

  const checkedStatus = () => {
    const data = {
      training_year: contractYear,
      company_sap_id: SAPId,
      company_name: contactName,
      active: 'true'
    }
    if(auth){
      setLoader(true)
      postCheckedStatus(data).then(res => {
        if(res.data.active === 'true' || res.data.active === true){
          res.data.contact_name ? setContactName(res.data.contact_name) : setContactName('N/A')
          res.data.contact_email ? setContactEmail(res.data.contact_email) : setContactEmail('N/A')
          setTrainingCompleted(true)
          setLoader(false)
        } else{
          setLoader(false)
        }
      })
    }
  }
  
  const unCheckedStatus = () => {
    const data = {
      training_year: contractYear,
      company_sap_id: SAPId,
      company_name: contactName,
      active: 'false'
    }
    if(auth){
      setLoader(true)
      patchCheckedStatus(data).then(res => {
        if(res.data.active === 'false' || res.data.active === false){
          setTrainingCompleted(false)
          setLoader(false)
        } else {
          setLoader(false)
        }
      })
    }
  }

  useEffect(()=> {
    
    const getProgramByProductionPlan = async() => {
      setProgramCheckLoader(true)
      try{
        const response = await getProgramAssignments(selectedProgramYear.production_plan_id, 'production_plan_id')

        let programExist = false
        if(response.data?.assignments.length > 0) {
          const { assignments } = response.data
          const filteredProgram = filteredProgramDetails.filter(program => program.id === assignments[0].program_id)
          
          if(filteredProgram.length > 0) {
            programExist = true
            setProgramExist(true)
            setSelectedProgramName({
              program_name: filteredProgram[0].value,
              program_id: filteredProgram[0].id
            })
            setOldProgramDetails({ ...oldProgramdetails, program_name: filteredProgram[0].value, assignment_id: assignments[0].assignment_id }) 
          }
        }
        if(!programExist){
          setProgramExist(false)
          setSelectedProgramName({
            program_name: '',
            program_id: ''
          })
          setOldProgramDetails({ ...oldProgramdetails, program_name: '', assignment_id:'' }) 
        }
        setProgramCheckLoader(false)
        
      }catch(err){
        setProgramCheckLoader(false)
      }
    }
    if(selectedProgramYear.production_plan_id !== '') {
      getProgramByProductionPlan()
    }
  },[selectedProgramYear, filteredProgramDetails])
  

  const handleProgramNameSelection = option => {
    const obj = {
      program_name: option.value, 
      program_id:option.id
    }
    setSelectedProgramName(obj)

    if(option.value === oldProgramdetails.program_name) {
      setProgramExist(true)
    }else{
      setProgramExist(false)
    }
  }

  const handleProgramYearSelection = option => {
    const obj = {
      production_plan_year: option.value, 
      production_plan_id: option.id 
    }
    setSelectedProgramYear(obj)
    setOldProgramDetails({ ...oldProgramdetails, program_year: option.value })
  }

  return (
    <div className='mb20'>
      {/* <Widget title='Company details' button={addOrEditButton}> */}
      <Widget title='Company details' >
        {renderData}
        {
          companyInfo?.company_type === 'reseller' ? 
            <> {
              loader ? 
                <div data-testid='tableStatusLoader' className='loader'/> : 
                trainingCompleted ? 
                  <>
                    <div className="df tableRow" style={{ cursor:'pointer' }}>
                      <img
                        data-testid="subrowArrow"
                        src={arrow}
                        className={`rowButton ${showCompanyDetails ? 'down' : ''}`}
                        alt="row arrow"
                        onClick={showCompanyDetailsFunc}
                        style={{ margin: 0 }}
                      />
                      <div className="df aic ml5" style={{ cursor: auth ? 'pointer' : 'default' }}>
                        <p className="tal c-darkgray fz16 m0 p0" onClick={unCheckedStatus}>{contractYear} Training Complete</p>
                        <img className="aifs ml10" alt="unchecked circle" src={checked} onClick={unCheckedStatus} />
                      </div>
                    </div>
                    <div style={{ display: showCompanyDetails ? 'block' : 'none' }}>
                      <div className="ml25 mt15">
                        <p className="tal c-darkgray fz14 mt10 mb0 p0">Contact Name</p>
                        <p className="tal c-darkgray fz14 m0 p0 fw600">{contactName}</p>
                        <p className="tal c-darkgray fz14 mt10 mb0 p0">Contact E-mail</p>
                        <p className="tal c-darkgray fz14 m0 p0 fw600">{contactEmail}</p>
                      </div>
                    </div>
                  </>
                  :
                  <div className="df" style={{ cursor:'pointer' }}>
                    <img
                      data-testid="subrowArrow"
                      src={arrow}
                      className='m0'
                      alt="row arrow"
                    />
                    <div className="df aic ml5" style={{ cursor: auth ? 'pointer' : 'default' }}>
                      <p className="tal c-darkgray fz16 m0 p0" onClick={checkedStatus}>{contractYear} Training Not Complete</p>
                      <img className="aifs ml10" alt="unchecked circle" src={unChecked} onClick={checkedStatus} />
                    </div>
                  </div>
            }
            <p className="tal c-darkgray fz16 mt10 mb0 p0 ml25 mt15">Enogen Dealer: {companyInfo?.enogen_dealer?'Yes':'No'}</p>
            </>
            : null
        }
      </Widget>
      {isNonEnogenDealer &&
          <Widget title='Non Enogen Contracts' >
            {
              nonEnogenLoader ? 
                <div data-testid='tableStatusLoader' className='loader'/> : 
                <div className="df" style={{ cursor:'pointer' }}>
                  <div className="df aic ml5">
                    <p className="tal c-darkgray fz16 m0 p0" onClick={nonEnogenStatus}>Allow Non Enogen Contracts</p>
                    <img className="aifs ml10" alt="circle" src={allowNonEnogenContracts? checked : unChecked} onClick={nonEnogenStatus} />
                  </div>
                </div>
            }
          </Widget>
      }

      { companyInfo?.company_type === 'grain-receiver' && isProgramsPermission &&
          <Widget title='Programs' >
            {
              programAssignLoader ? 
                <div data-testid='tableStatusLoader' className='loader'/> : 
                <div>
                  <div className="ml5 w80% ">
                    <label>Production Plan</label>
                    <Select
                      placeholder='Select Year'
                      defaultValue={selectedProgramYear.production_plan_year}
                      className='mt10 mb10'
                      handleSelection={handleProgramYearSelection}
                      options={contractYears}
                    />
                  </div>
                  {programCheckingLoader ? 
                    <div data-testid='tableStatusLoader' className='loader'/> : 
                    <div className=" ml5 w80% ">
                      <label>Program Name</label>
                      <Select
                        placeholder='Select Program'
                        defaultValue={selectedProgramName.program_name}
                        className='mt10 mb10'
                        handleSelection={handleProgramNameSelection}
                        options={filteredProgramDetails}
                      />
                    </div>
                  }
                  <div className='df'>
                    <Button 
                      type='success'
                      text='Save' 
                      customClassName='p10 ml5 mt5' 
                      disabled= { !selectedProgramName.program_name || !selectedProgramYear.production_plan_year }
                      onClick={assignProgramAssignments}
                    />
                    {isProgramExist ?    
                      <Button 
                        type='error'
                        text='Delete' 
                        customClassName='p10 ml12 mt5' 
                        onClick={deleteProgram}
                      /> : null
                    }
                  </div>

                </div>
            }
          </Widget>
      }
      <Modal
        autoHeight
        show={showCompanyDetailsModal}
        handleClose={handleCompanyDetailsModalClose}
      >
        <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
          <div className='df jcsb'>
            <p className='fz16 ml20 fw600'>Add new detail</p>
            <button className='bdnone mr20 bgc-t' onClick={handleCompanyDetailsModalClose}>
              <img src={deleteIcon} alt='cancel button' />
            </button>
          </div>
          <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
         
          <div className='ml30 mr30'>
            <form onSubmit={_handleSubmit}>
              <div className='fll mb5 fz15'>Name*</div>
              <input type='text' name='details_name' value={newDetailName} onChange={e => setNewDetailName(e.target.value)} placeholder='Name' ref={register({ required: true, minLength: 1 })} />
              <div className='c-red tal fz15 mt5'>
                {errors.details_name && errors.details_name.type === 'required' && 'Please provide detail name'}
              </div>
              <div className='mt20 fll mb5 fz15'>Detail*</div>
              <textarea className='w100% h250 rszn' type='text' name='details_value' value={newDetailValue} onChange={e => setNewDetailValue(e.target.value)} ref={register({ required: true, minLength: 1 })} />
              <div className='c-red tal fz15 mt5'>
                {errors.details_value && errors.details_value.type === 'required' && 'Please provide detail description'}
              </div>
            </form>
          </div>
          <hr className='mt0 mb16 mt16 bdnone bt1-s-lightgray'/>
          <div className='w100% tar'>
            <Button type='success' text='Submit' customClassName='mr10' clickHandler={_handleSubmit}/>
            <Button text='Cancel' customClassName='mr10' clickHandler={handleCancel}/>
          </div>
        </div>
      </Modal>
      {showWarning
        ?
        <Warning
          warningMessage={isLoading ? `Deleting "${detailName}" detail, please wait...` :`You are about to delete "${detailName}" detail. Are you sure?`}
          confirmationButtonText='Yes, delete'
          handleSubmit={() => handleDeleteDetail(detailIndex)}
        />
        :
        null
      }
    </div>
  )
}

export default CompanyDetailComponent